module.exports = __webpack_public_path__ + "img/network_videos.a50f76e0.svg";